/**
 * 見出しラベルの括弧部分を 2 行目に落として表示する共有コンポーネント。
 *
 * 「実績戦闘力（処理中含め）」「実績Pt（処理中Pt）」「要件定義pt（処理中含め）」のような
 * 長い見出しを本文 + 括弧補足の 2 段に分け、列幅を圧迫しないようにする。括弧が無いラベルは
 * 1 行のまま。戦闘力テーブル (`TeamTable`) と要件定義テーブル (`RequirementDefinitionTable`)
 * が同じカードに並ぶので、**見出しの字面は 1 実装に寄せる**（別実装にすると括弧行のフォント
 * サイズや寄せがいつの間にかズレる）。
 *
 * 括弧行は本文・数字と同じ右端に揃える。全角括弧「）」は字面に右アキ (side bearing) を持ち、
 * 右揃えしても数字列の右端より内側に見えるため、表示時に半角括弧へ寄せて字面の右端を合わせる
 * (数字側も「43(6)」のように半角括弧で表示している)。
 *
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering
 * @graph-business 戦闘力/要件定義テーブルの見出しを本文 + 括弧補足の 2 行に分けて右揃え表示する (括弧は半角へ正規化)
 * @graph-connects none
 */

/** @graph-connects none */
export function TwoLineHeaderLabel({ label }: { label: string }) {
  const match = /^(.*?)\s*([（(].*)$/.exec(label);
  if (!match) return <>{label}</>;
  const [, main, paren] = match;
  const halfWidthParen = paren.replace(/[（）]/g, (c) => (c === '（' ? '(' : ')'));
  return (
    <span className="inline-flex flex-col items-end leading-tight">
      <span className="whitespace-nowrap">{main}</span>
      <span className="text-[10px] font-normal text-[var(--color-text-muted)] whitespace-nowrap">
        {halfWidthParen}
      </span>
    </span>
  );
}
